import { rest } from 'msw';

export const handlers = [
  rest.get('*/projects/', (req, res, ctx) => {
    return res(
      ctx.status(400),
      ctx.json({
        detail: 'test',
      })
    );
  }),
];
